export enum RoutePath {
    ROOT = '/',
    PRODUCT_TYPE = '/productType',
    AREA_AND_STYLE = '/areaAndStyle',
    CUSTOMISE = '/customise',
    CONFIRM_ORDER = '/confirm-order',
}
